import { Injectable, OnDestroy } from '@angular/core';
import {
  ServicingCommonStore,
  selectServicingCommonState,
  setServicingCommon,
  updateServicingCommon,
} from '@common/store/servicing-common';
import { ServicingCommonModel } from '@common/interfaces/servicing-common';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ServicingCommonStoreService implements OnDestroy {
  private _subscriptions: Subscription[] = [];
  private _servicingCommon$: Observable<ServicingCommonModel>;
  private _servicingCommon: ServicingCommonModel = {};
  public get servicingCommon(): ServicingCommonModel {
    return this._servicingCommon;
  }

  constructor(private _store: Store<ServicingCommonStore>) {
    this._servicingCommon$ = this._store.pipe(
      select(selectServicingCommonState),
      map((state) => state.model || {})
    );
    this._subscriptions.push(
      this._servicingCommon$.subscribe((data) => {
        this._servicingCommon = data;
      })
    );
  }

  ngOnDestroy(): void {
    this._subscriptions
      .filter((subscription) => subscription != null)
      .forEach((subscription) => subscription.unsubscribe());
  }

  /**
   * サービシング共通Storeのモデルを取得するObservableを取得
   * @returns サービシング共通Storeのモデルを取得するObservable
   */
  public getServicingCommonModel$(): Observable<ServicingCommonModel> {
    return this._servicingCommon$;
  }

  /**
   * サービシング共通Storeを指定された状態に上書きする
   * @param state 上書きを行うState
   */
  public setServicingCommon(model: ServicingCommonModel) {
    this._store.dispatch(setServicingCommon({ model }));
  }

  /**
   * サービシング共通Storeの指定されたパラメータを更新する
   * @param state 更新を行うState
   */
  public updateServicingCommon(model: ServicingCommonModel) {
    this._store.dispatch(
      updateServicingCommon({
        model: {
          ...this._servicingCommon,
          ...model,
        },
      })
    );
  }
}
